exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "td[data-v-4d149a5f],th[data-v-4d149a5f]{border-bottom:1px solid #aaa!important;padding:5px 0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-4d149a5f&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Precos.vue
// module id = 44
// module chunks = 0